import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .RSViewAllBtn': {
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
}));
export default StyledBox;
